if (!customElements.get('item-carousel')) {
  customElements.define(
    'item-carousel',
    class ItemCarousel extends HTMLElement {
      constructor() {
        super();

        /** @type {HTMLElement | null} */
        this.carousel = this.querySelector('[data-carousel]');

        /** @type {HTMLElement | null} */
        this.scrollbar = this.querySelector('[data-carousel-scrollbar]');

        /** @type {HTMLElement | null} */
        this.next = this.querySelector('[data-carousel-next]');

        /** @type {HTMLElement | null} */
        this.prev = this.querySelector('[data-carousel-prev]');

        /** @type {import('swiper').Swiper | null} */
        this.instance = null;

        /** @type {HTMLImageElement[]} */
        this.images = Array.from(this.querySelectorAll('img'));
      }

      connectedCallback() {
        const swiper = window.swiper.Swiper;

        if (this.carousel && this.scrollbar) {
          this.instance = new swiper(this.carousel, {
            modules: [window.swiper.Scrollbar, window.swiper.Navigation],
            cssMode: true,
            slidesPerView: Number(this.getAttribute('data-carousel-slides')) || 1,
            spaceBetween: Number(this.getAttribute('data-carousel-gap')) || 12,
            scrollbar: {
              el: this.scrollbar,
              hide: false,
            },
            navigation: {
              nextEl: this.next,
              prevEl: this.prev,
            },
            breakpoints: {
              600: {
                slidesPerView: Number(this.getAttribute('data-carousel-slides-sm')) || 2,
                spaceBetween: Number(this.getAttribute('data-carousel-gap-sm')) || 16,
              },
              1200: {
                slidesPerView: Number(this.getAttribute('data-carousel-slides-md')) || 3,
                spaceBetween: Number(this.getAttribute('data-carousel-gap-md')) || 24,
              },
              1600: {
                slidesPerView: Number(this.getAttribute('data-carousel-slides-lg')) || 4,
                spaceBetween: Number(this.getAttribute('data-carousel-gap-lg')) || 32,
              },
            },
            on: {
              resize: (e) => {
                if (e.isLocked) {
                  this.setAttribute('data-carousel-locked', '');
                } else {
                  this.removeAttribute('data-carousel-locked');
                }
              },
              slideChange: () => {
                this.images.forEach((image) => {
                  if (image && image.getAttribute('loading') !== 'eager') image.setAttribute('loading', 'eager');
                });
              },
            },
          });
        }
      }
    },
  );
}
